import { api } from './client';

/** Asistentes automáticos (plantillas, no IA) + reporte por agente. ADMIN. */

export interface AssistantStatus {
  key: string;
  nombre: string;
  queHace: string;
  plantillas: string[];
  /** Variables disponibles por plantilla (chips del editor inline). */
  variables: Record<string, string[]>;
  worker?: string;
  estado: 'activo' | 'sin_plantilla' | 'worker_caido' | string;
  enviados: number;
  ultimoAt: string | null;
}

export interface AgentReport {
  agentId: string;
  nombre: string;
  desde: string;
  hasta: string;
  turnos: number;
  promedioRespuestaMs: number | null;
  inputTokens: number;
  outputTokens: number;
  /** Solo lo recibe el OWNER; para el cliente el campo no viene. */
  costoUsd?: number;
  usosCli: number;
  mensajesEnviados: number;
  leadsRegistrados: number;
  porLeadStatus: Record<string, number>;
  escaladosAHumano: number;
}

const rangeQs = (desde?: Date, hasta?: Date) => {
  const params = new URLSearchParams();
  if (desde) params.set('desde', desde.toISOString());
  if (hasta) params.set('hasta', hasta.toISOString());
  const qs = params.toString();
  return qs ? `?${qs}` : '';
};

export const getAssistants = (desde?: Date, hasta?: Date) =>
  api.get<AssistantStatus[]>(`/api/assistants${rangeQs(desde, hasta)}`);

export const getAgentReport = (id: string, desde: Date, hasta: Date) =>
  api.get<AgentReport>(`/api/agents/${id}/report${rangeQs(desde, hasta)}`);
